const hiddenKeys = new Set([
    'source', 'sources', 'reference', 'references', 'citation', 'citations',
    'sourceurl', 'sourcename', 'sourcelabel', 'vettingsources', 'academicsources',
    'groundingchunks', 'verifiedlinks', 'url', 'uri', 'links', 'accessendpoints',
]);

function stripLinks(value: string): string {
    return value
        .replace(/<a\b[^>]*>([\s\S]*?)<\/a>/gi, '$1')
        .replace(/\[([^\]]+)]\((?:https?:\/\/|www\.)[^)]+\)/gi, '$1')
        .replace(/<(?:https?:\/\/|www\.)[^>]+>/gi, '')
        .replace(/(?:https?:\/\/|www\.)[^\s<]+/gi, '')
        .replace(/[ \t]+([,.;:!?])/g, '$1')
        .replace(/[ \t]{2,}/g, ' ')
        .trimEnd();
}

export function redactDailyMicroReport<T>(value: T): T {
    if (typeof value === 'string')
        return stripLinks(value) as T;
    if (Array.isArray(value))
        return value
            .filter(item => {
                if (!item || typeof item !== 'object')
                    return true;
                if (!('heading' in item) && !('content' in item))
                    return true;
                const heading = String((item as any).title || (item as any).heading || '').toLowerCase();
                return !/\b(sources?|references?|citations?)\b/.test(heading);
            })
            .map(redactDailyMicroReport) as T;
    if (!value || typeof value !== 'object')
        return value;

    const result: Record<string, unknown> = {};
    for (const [key, item] of Object.entries(value)) {
        const normalized = key.toLowerCase().replace(/[^a-z]/g, '');
        if (!hiddenKeys.has(normalized))
            result[key] = redactDailyMicroReport(item);
    }
    return result as T;
}
